import React from 'react';

const LoadingSpinner = ({ size = 'md', text = '' }) => {
    const sizeClasses = {
        sm: 'w-5 h-5',
        md: 'w-8 h-8',
        lg: 'w-12 h-12',
    };

    return (
        <div className="flex items-center justify-center py-8">
            <div className="flex flex-col items-center gap-3">
                <div
                    className={`${sizeClasses[size] || sizeClasses.md} border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin`}
                />
                {text && <p className="text-gray-500 text-sm">{text}</p>}
            </div>
        </div>
    );
};

export default LoadingSpinner;